(function () {
	'use strict';

	angular.module('DcExpositionModule').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('expositions-parent', {
			url: '/exposition',
			parent: 'target-project',
			abstract: true,
		});

		$stateProvider.state('expositions', {
			url: '/',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: 'member',
				title: 'DataAPIs',
			},
			views: {
				'@expositions-parent': {
					template: `<app-expositions-list ng-prop-project_label="$ctrl.projectLabel" ng-prop-embedded="false"
																					 ng-prop-datablock_id="null"></app-expositions-list>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('exposition-new', {
			url: '/create',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Nouvelle DataAPI',
			},
			views: {
				'@expositions-parent': {
					controller: [
						'$timeout',
						'NgExpositions',
						function ($timeout, NgExpositions) {
							$timeout(function () {
								NgExpositions.openCreateNewExpositionModal();
							}, 16);
						},
					],
				},
			},
		});

		$stateProvider.state('exposition-view', {
			url: '/:expositionId/view',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'DataAPI',
			},
			resolve: {
				targetExposition: [
					'$stateParams',
					'NgExpositions',
					function ($stateParams, NgExpositions) {
						NgExpositions.getInViewExpositionId().then((val) => {
							if (+$stateParams.expositionId !== val) {
								NgExpositions.selectExposition(+$stateParams.expositionId);
							}
						});
					},
				],
			},
			views: {
				'@expositions-parent': {
					template: `<app-exposition-view ng-prop-exposition_id="$ctrl.expositionId"
																					ng-prop-project_label="$ctrl.projectLabel"></app-exposition-view>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const expositionId = parseInt($stateParams['expositionId'], 10);
								$ctrl.expositionId = !Number.isNaN(expositionId)
									? expositionId
									: null;
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('exposition-data-simulator', {
			url: '/:expositionId/simulator',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'DataAPI',
			},
			views: {
				'@expositions-parent': {
					template: `<app-exposition-simulator ng-prop-exposition_id="$ctrl.expositionId"
																							 ng-prop-project_label="$ctrl.projectLabel"></app-exposition-simulator>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const expositionId = parseInt($stateParams['expositionId'], 10);
								$ctrl.expositionId = !Number.isNaN(expositionId)
									? expositionId
									: null;
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('exposition-history', {
			url: '/:expositionId/history',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'DataAPI',
			},
			views: {
				'@expositions-parent': {
					template: `<app-exposition-history-list ng-prop-exposition_id="$ctrl.expositionId"
																									ng-prop-project_label="$ctrl.projectLabel"></app-exposition-history-list>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const expositionId = parseInt($stateParams['expositionId'], 10);
								$ctrl.expositionId = !Number.isNaN(expositionId)
									? expositionId
									: null;
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('exposition-edit-columns', {
			url: '/:expositionId/edit/columns',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Modifier colonnes DataAPI',
			},
			views: {
				'@expositions-parent': {
					controller: [
						'$timeout',
						'NgExpositions',
						'$stateParams',
						function ($timeout, NgExpositions, $stateParams) {
							const $ctrl = this;
							init();
							function init() {
								const expositionId = parseInt($stateParams['expositionId'], 10);
								$timeout(function () {
									NgExpositions.openEditExpositionColumnsModal(expositionId);
								}, 16);
							}
						},
					],
				},
			},
		});

		$stateProvider.state('exposition-edit-api', {
			url: '/:expositionId/access/:accessId',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Modifier DataAPI',
			},
			views: {
				'@expositions-parent': {
					controller: [
						'$timeout',
						'NgExpositions',
						'$stateParams',
						function ($timeout, NgExpositions, $stateParams) {
							const $ctrl = this;
							init();
							function init() {
								const expositionId = parseInt($stateParams['expositionId'], 10);
								$timeout(function () {
									NgExpositions.openEditExpositionApiModal(
										expositionId,
										$stateParams['accessId']
									);
								}, 16);
							}
						},
					],
				},
			},
		});

		$stateProvider.state('expositions-migrate', {
			url: '/migrations',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: 'member',
				title: 'Expositions Migrate v1',
			},
			views: {
				'@expositions-parent': {
					template: `<app-exposition-migrations-list ng-prop-project_label="$ctrl.projectLabel"></app-exposition-migrations-list>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('exposition-init-migration', {
			url: '/init',
			parent: 'expositions-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Nouvelle migration',
			},
			views: {
				'@expositions-parent': {
					controller: [
						'$timeout',
						'NgExpositions',
						function ($timeout, NgExpositions) {
							$timeout(function () {
								NgExpositions.openInitNewExpositionMigration();
							}, 16);
						},
					],
				},
			},
		});
	}
})();
